import moment from 'moment';

export const formatDate = (date: string): string => {
  return date ? moment(new Date(date)).format('M/D/YYYY') : '-';
};

export const formatTime = (date: string): string => {
  return date ? moment(new Date(date)).format('h:mm A') : '-';
};
